'use strict';

import { baseInit, baseInitGpt, baseSetupHeroSkin } from './_base.js';
import affiliateLinks from '../utils/affiliate-links';

export function init() {
	baseInit();
	affiliateLinks.init();
}

export function initGpt(adConfig) {
	baseInitGpt(adConfig);
}

export function setupHeroSkin(options) {
	baseSetupHeroSkin(options);
}